const columns = t => [
  {
    title: t('CONFIG_REPORT_STRUCTURE_FIELD'),
    dataIndex: 'name',
  },
];

export default columns;
